import { NgControl } from '@angular/forms';
import { Directive, Input, inject } from '@angular/core';

@Directive({
  selector: '([formControlName], [formControl])[disabledControl]',
  standalone: true,
})
export class BoschUiDisableControlDirective {
  private readonly ngControl = inject(NgControl, { optional: true });
  @Input() set disabledControl(condition: boolean) {
    this.ngControl?.valueAccessor?.setDisabledState(!!condition);
  }
}
